import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Calendar, ArrowLeft } from "lucide-react";
import { apiWeeklyUpdates, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function WeeklyUpdates() {
  const [items, setItems] = useState(null);
  const [active, setActive] = useState(null);

  useEffect(() => {
    (async () => {
      try { setItems(await apiWeeklyUpdates()); }
      catch (e) { toast.error(formatApiError(e)); setItems([]); }
    })();
  }, []);

  if (active) {
    return (
      <section className="pt-10 pb-20 max-w-3xl mx-auto" data-testid="weekly-update-detail">
        <button
          onClick={() => setActive(null)}
          data-testid="weekly-back"
          className="inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-[0.25em] text-neutral-400 hover:text-white mb-4"
        >
          <ArrowLeft className="w-3.5 h-3.5" /> all updates
        </button>
        <motion.article
          initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}
          className="border border-neutral-900 bg-neutral-950 p-8"
        >
          <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#00E5FF] mb-3">
            <Calendar className="inline w-3 h-3 mr-1" /> {new Date(active.sent_at).toLocaleDateString(undefined, { dateStyle: "long" })}
          </div>
          <h1 className="text-3xl font-black tracking-tighter text-white mb-5">{active.subject}</h1>
          <div
            className="prose prose-invert max-w-none text-neutral-200 leading-relaxed weekly-update-body"
            data-testid="weekly-update-body"
            dangerouslySetInnerHTML={{ __html: active.body_html }}
          />
        </motion.article>
        <style>{`
          .weekly-update-body h2 { font-size: 1.5rem; font-weight: 900; margin: 1.25rem 0 0.5rem; color: #fff; }
          .weekly-update-body p { margin: 0.75rem 0; }
          .weekly-update-body ul { padding-left: 1.25rem; list-style: disc; margin: 0.75rem 0; }
          .weekly-update-body a { color: #00E5FF; text-decoration: underline; }
        `}</style>
      </section>
    );
  }

  return (
    <section className="pt-10 pb-20 max-w-3xl mx-auto" data-testid="weekly-updates-page">
      <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}>
        <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#00E5FF] mb-3">
          ── members archive ──
        </div>
        <h1 className="text-3xl sm:text-4xl font-black tracking-tighter text-white">Weekly Updates</h1>
        <p className="text-sm text-neutral-400 mt-1.5">
          Bitcoin outlooks, market updates, and platform announcements — newest first.
        </p>

        <div className="mt-8 space-y-3" data-testid="updates-list">
          {items === null && (
            <div className="text-xs font-mono text-neutral-600 uppercase tracking-[0.25em] py-8">loading…</div>
          )}
          {items && items.length === 0 && (
            <div className="text-xs font-mono text-neutral-600 uppercase tracking-[0.25em] py-8">no updates yet</div>
          )}
          {items?.map((u) => (
            <button
              key={u.id}
              onClick={() => setActive(u)}
              data-testid={`update-${u.id}`}
              className="block w-full text-left border border-neutral-900 hover:border-neutral-700 bg-neutral-950 p-5 transition-colors"
            >
              <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-neutral-500 mb-1">
                {new Date(u.sent_at).toLocaleDateString(undefined, { dateStyle: "medium" })}
              </div>
              <div className="font-bold text-white text-base">{u.subject}</div>
            </button>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
